export const update = {
  updateSuccessfully: '洗剤の履歴を正常に更新しました!',
}
